// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
    production: false,
    cmsServiceURL:
        "https://saferoadsph-reports-service-mysql-demo.azurewebsites.net/api/v1",
    userServiceURL: "https://saferoadsph-user-service-mysql-demo.azurewebsites.net/api/v1",
    courseServiceURL:
        "https://saferoadsph-modules-service-mysql-demo.azurewebsites.net/api/v1",
    paymentServiceURL:
        "https://saferoadsph-payments-service-mysql-demo.azurewebsites.net/api/v1",
    reportServiceURL:
        "https://saferoadsph-reports-service-mysql-demo.azurewebsites.net/api/v1", 
    luxandToken: "df16be834f434cd787f8064b2d41a930", // saferoad account
    //qrCodeCreateAccountURL: "https://saferoads.ph/create-account-with-dscode/",
    //branchQRCodeCreateAccountURL: "https://saferoads.ph/create-account-with-branchcode/",
    //url: 'https://saferoads.ph',
    qrCodeCreateAccountURL: "https://demo.saferoads.ph/create-account-with-dscode/",
    branchQRCodeCreateAccountURL: "https://demo.saferoads.ph/create-account-with-branchcode/",
    url: 'https://demo.saferoads.ph',
    passwordPolicy: {
        useMockApi: false,
        minLength: 12,
        maxLength: 32,
        requireUppercase: true,
        requireLowercase: true,
        requireNumber: true,
        requireSpecialCharacter: true,
        specialCharacterPattern: '[^A-Za-z0-9]',
        enableHistoryCheck: false,
        preventReuseCount: 5,
        enableExpirationCheck: false,
        expireAfterDays: 90,
    },
};
